import { Loader2 } from "lucide-react";

export function Spinner({ label, className = "" }) {
  return (
    <div className={`flex min-h-[40vh] flex-col items-center justify-center gap-3 text-muted-foreground ${className}`}>
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
      {label ? <p className="text-sm">{label}</p> : null}
    </div>
  );
}
